import { takeLatest, call, put, select } from 'redux-saga/effects';
import axios from 'axios';
import { authAdminRequest, authAdminSuccess, authAdminFailure } from '../reducers/login';
import { turnitinGetEulaRequest } from '../reducers/turnitin';
import { API_LINK } from '../../constants';
import { shouldShowTurnitinEula } from '../../utils/shouldShowTurnitinEula';

const API = `${API_LINK}api/getAuthUser`;

function* authAdminFunctionAxios() {
  const state = yield select(fullState => fullState);
  const { token } = state.loginReducer;
  
  return yield call(() =>
    axios({
      method: 'post',
      url: API,
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      credentials: 'same-origin',
      data: {
        token,
      },
    }),
  );
}

function* workerAuthAdminSaga() {
  try {
    const response = yield call(authAdminFunctionAxios);
    const responseFromLogin = response.data;

    if (response.status === 200) {
      yield put(authAdminSuccess(responseFromLogin));

      if (shouldShowTurnitinEula(responseFromLogin)) {
        yield put(turnitinGetEulaRequest());
      }
    }
    if (response.status === 401) {
      yield put(authAdminFailure(response));
    }
    if (response.status === 500) {
      yield put(authAdminFailure(response));
    }
  } catch (error) {
    yield put(authAdminFailure(error.response));
  }
}

export function* watcherAuthAdminSaga() {
  yield takeLatest(authAdminRequest().type, workerAuthAdminSaga);
}
